// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';

import {
  assetResolver,
  isActiveLink,
} from '../../utils';

import {
  navigationItemPropType,
} from '../../propTypes';

import {
  Item,
  NavigationItemContainer,
  ArrowLeft,
  NavigationItemLink,
} from './styles';

const PrimaryNavigationMenuItem = ({ item }) => {
  const current = navigationItem => ((isActiveLink(navigationItem.link)) ? 'page' : 'false');

  return (
    <NavigationItemContainer>
      <NavigationItemLink
        aria-label={item.title}
        aria-current={current(item)}
        href={item.link || null}
        active={isActiveLink(item.link)}
      >
        <Item>
          {item.return && <ArrowLeft src={assetResolver('arrow-left.svg')} alt="Back" />}
          {item.icon && <img src={assetResolver(`${item.icon}.svg`)} alt="Icon" />}
          {item.image && <img src={item.image} alt={item.imageAlt} />}
          {!item.image && <span>{item.title}</span>}
        </Item>
      </NavigationItemLink>
    </NavigationItemContainer>
  );
};

PrimaryNavigationMenuItem.propTypes = {
  item: navigationItemPropType,
};

PrimaryNavigationMenuItem.defaultProps = {
  item: null,
};

export default PrimaryNavigationMenuItem;
